var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.72,
    height: 66.797,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 96.084,
    x2: 96.084,
    y1: 2.758,
    y2: 62.524,
    gradientTransform: "scale(.99942 1.00058)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008EF3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 1.117,
    height: 1.117,
    x: -0.059,
    y: -0.042,
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m125.869 37.456.025-9.398-6.699-.021a23.4 23.4 0 0 0-3.469-8.355l4.778-4.761-6.618-6.664-4.809 4.79a23.5 23.5 0 0 0-8.292-3.458l.017-6.804-9.386-.025-.017 6.808a23.5 23.5 0 0 0-8.31 3.411l-4.785-4.82-6.653 6.628 4.75 4.782a23.4 23.4 0 0 0-3.518 8.34l-6.695-.017-.025 9.398 6.74.022a23.3 23.3 0 0 0 3.449 8.333l-4.8 4.782 6.618 6.664 7.008-6.98v-8.497c-1.987-2.477-3.212-5.617-3.212-8.94 0-7.707 6.305-13.98 14.062-13.98 7.754 0 14.062 6.273 14.062 13.98 0 6.093-3.968 11.234-9.45 13.144V39.07c1.999-1.434 3.311-3.757 3.311-6.396 0-4.359-3.546-7.893-7.923-7.893-4.376 0-7.922 3.534-7.922 7.893 0 2.565 1.248 4.824 3.152 6.266v23.62h9.383v-6.776c3.025-.6 5.836-1.78 8.327-3.415l4.785 4.817 6.652-6.628-4.746-4.782a23.4 23.4 0 0 0 3.515-8.338z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd"
    },
    transform: "translate(-62.639 -.248)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      fill: "#000",
      filter: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      fill: "url(#d)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosAdmin);
export default __webpack_public_path__ + "static/media/logosAdmin.78d3cd5c84fa426253e8892aa452581a.svg";
export { ForwardRef as ReactComponent };